import { FC, MutableRefObject, useRef } from 'react'
import { useWindowSize } from 'react-use'
import { getStyledContentWrapper } from '../../styled-components/ContentWrapper.styled'
import { MD_SCREEN } from '../../util/screen-size'
import { NavBar, refTypes } from '../navbar/NavBar.component'
import { SectionHolder } from './SectionHolder.component'

export interface ContentWrapperProps {
    
}

export const ContentWrapper: FC<ContentWrapperProps> = (props) => {
    const homeRef = useRef(null)
    const featureRef = useRef(null)
    const aboutRef = useRef(null)
    const contactRef = useRef(null)

    const moveContent = (itemRef: MutableRefObject<any>) => {
        window.scrollTo({
            top: itemRef.current.offsetTop,
            behavior: 'smooth'
        })
    }

    const passingRefs: refTypes = {
        home: homeRef,
        feature: featureRef,
        about: aboutRef,
        contact: contactRef
    }

    const {width} = useWindowSize();
    const size = width > MD_SCREEN

    const StyledContentWrapper = getStyledContentWrapper(size)

    return (
        <StyledContentWrapper>
            <NavBar refList={passingRefs} action={moveContent}/>
            <SectionHolder refList={passingRefs} />
        </StyledContentWrapper>
    )
}